import { getSecureBaseUrl } from '../../../services/UrlMapperService';
import { HttpService } from '../../../services/HttpService';

const logger = (info, addlinfo) => {
  const eventType = 'FEERROR';
  const pageName = window.location.pathname
    .split('/')
    .pop()
    .split('.')[0];
  const data = {
    messageType: 'FEINFO',
    eventType,
    loggerMessage: {
      message: info,
      loglevel: 'loglevel',
      id: 'id',
      userAgent: navigator.userAgent,
      pageTitle: pageName,
      host: window.location.host,
      stackTrace: 'stacktrace',
      componentStack: addlinfo,
    },
  };
  HttpService.post(` ${getSecureBaseUrl()}/peripheralsservice/jsNotifyAsDynamic`, data).catch((e) => {
    console.log('logger.js', e);
  });
};

export default logger;
